<template>
  <div class="header" id="header">
    <nav class="navbar navbar-light bg-white flex-md-nowrap p-10 shadow">
      <div class="row">
        <div class="col-md-8"></div>
        <div class="col-md-4 text-right">
          <autocomplete
            :placeholder="$t('Rechercher un rapport')"
            v-model="recherche"
            id="recherche"
            :source="getDAE"
            input-class="form-control"
            results-property="data"
            :resultsFormatter="resultAE"
            :results-display="formattedAE"
            @selected="getAE($event)"
            :delay="500"
          ></autocomplete>
          <span class="material-icons sicRecherche">search</span>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "RwvHeader",
  data() {
    return {
      recherche: "",
    };
  },
  methods: {
    getDAE(obj) {
      if (obj.length < 3) return false;
      return (
        this.$apiUrl +
        "demandes/ae/" +
        obj +
        "?auth=" +
        JSON.stringify(this.auth_header())
      );
    },
    resultAE(response) {
      return response;
    },
    formattedAE(result) {
      if (result) return result.result;
    },
    getAE(group) {
      window.location.href = group.selectedObject.link;
    },
  },
};
</script>
